module.exports = __webpack_public_path__ + "static/media/description.11b49cd8.png";